import {
  AfterContentInit,
  Component,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { MuiHeroAreaService } from '../mui-hero-area.service';

@Component({
  selector: 'mui-hero-content',
  templateUrl: './mui-hero-content.component.html',
  styles: [
    `
      :host {
        display: none;
      }
    `
  ]
})
export class MuiHeroContent implements AfterContentInit {
  @Input() background: { class?: string; url?: string } = {};

  @ViewChild('contentTemplate') titleTemplate?: TemplateRef<any>;
  @ViewChild('toolbarTemplate') toolbarTemplate?: TemplateRef<any>;
  @ViewChild('fullscreenHeaderTemplate') fullscreenHeaderTemplate?: TemplateRef<any>;

  constructor(private heroAreaService: MuiHeroAreaService) {}

  ngAfterContentInit(): void {
    this.heroAreaService.heroContent = this;
  }

}
